import ListWrapper from "../utils/ListWrapper";
import D3EAppTemplate from "./D3EAppTemplate";
import DBObject from "../utils/DBObject";
import CloneContext from "../utils/CloneContext";
import CollectionUtils from "../utils/CollectionUtils";

export default class D3EAppTemplateCategory extends DBObject {
  private static readonly _APPS: number = 0;
  private static readonly _TITLE: number = 1;
  public id: number = 0;
  public otherMaster: DBObject;
  private _title: string = "";
  private _apps: Array<D3EAppTemplate> = ListWrapper.inverse(
    this,
    "apps",
    D3EAppTemplateCategory._APPS
  );
  public constructor(
    d3eParams?: Partial<{ apps: Array<D3EAppTemplate>; title: string }>
  ) {
    super();

    this.setApps(
      d3eParams?.apps ??
        ListWrapper.inverse(this, "apps", D3EAppTemplateCategory._APPS)
    );

    this.setTitle(d3eParams?.title ?? "");
  }
  public get d3eType(): string {
    return "D3EAppTemplateCategory";
  }
  public static updateAppsInverse(on: any, obj: any, type: string): void {
    if ("Insert" === type) {
      on.addToApps(obj as D3EAppTemplate);
    }

    if ("Delete" === type) {
      on.removeFromApps(obj as D3EAppTemplate);
    }
  }
  public clear(): void {
    this.d3eChanges.clear();
  }
  public get title(): string {
    return this._title;
  }
  public setTitle(val: string): void {
    let isValChanged: boolean = this._title !== val;

    if (!isValChanged) {
      return;
    }

    this.updateD3EChanges(D3EAppTemplateCategory._TITLE, this._title);

    this._title = val;

    this.fire("title", this);
  }
  public get apps(): Array<D3EAppTemplate> {
    return this._apps;
  }
  public setApps(val: Array<D3EAppTemplate>): void {
    let isValChanged: boolean = CollectionUtils.isNotEquals(this._apps, val);

    if (!isValChanged) {
      return;
    }

    if (!this.d3eChanges.contains(D3EAppTemplateCategory._APPS)) {
      let _old: Array<D3EAppTemplate> = Array.from(this._apps);

      this.updateD3EChanges(D3EAppTemplateCategory._APPS, _old);
    }

    this.updateObservableColl("apps", this._apps, val);

    this._apps.clear();

    this._apps.addAll(val);

    this.fire("apps", this);
  }
  public addToApps(val: D3EAppTemplate, index: number = -1): void {
    let _old: Array<D3EAppTemplate> = [];

    let _isNewChange: boolean = !this.d3eChanges.contains(
      D3EAppTemplateCategory._APPS
    );

    if (_isNewChange) {
      _old = Array.from(this._apps);
    }

    if (index === -1) {
      if (!this._apps.contains(val)) this._apps.add(val);
    } else {
      this._apps.remove(this._apps.elementAt(index));

      this._apps.add(val);
    }

    this.fire("apps", this, val, true);

    this.updateObservable("apps", null, val);

    if (_isNewChange) {
      this.updateD3EChanges(D3EAppTemplateCategory._APPS, _old);
    }
  }
  public removeFromApps(val: D3EAppTemplate): void {
    let _old: Array<D3EAppTemplate> = [];

    let _isNewChange: boolean = !this.d3eChanges.contains(
      D3EAppTemplateCategory._APPS
    );

    if (_isNewChange) {
      _old = Array.from(this._apps);
    }

    this._apps.remove(val);

    this.fire("apps", this, val, false);

    if (_isNewChange) {
      this.updateD3EChanges(D3EAppTemplateCategory._APPS, _old);
    }
  }
  public get(field: number): any {
    switch (field) {
      case D3EAppTemplateCategory._TITLE: {
        return this._title;
      }

      case D3EAppTemplateCategory._APPS: {
        return this._apps;
      }
      default: {
        return null;
      }
    }
  }
  public updateD3EChanges(index: number, value: any): void {
    if (this.lockedChanges()) {
      return;
    }

    super.updateD3EChanges(index, value);
  }
  public restore(): void {
    /*
TODO: Might be removed
*/

    this.d3eChanges.restore(this);
  }
  public deepClone(clearId = true): D3EAppTemplateCategory {
    let ctx: CloneContext = new CloneContext({ "clearId": clearId });

    return ctx.startClone(this);
  }
  public collectChildValues(ctx: CloneContext): void {}
  public deepCloneIntoObj(dbObj: DBObject, ctx: CloneContext): void {
    let obj: D3EAppTemplateCategory = dbObj as D3EAppTemplateCategory;

    obj.id = this.id;

    obj.setTitle(this._title);

    obj.setApps(this._apps);
  }
  public set(field: number, value: any): void {
    switch (field) {
      case D3EAppTemplateCategory._TITLE: {
        this.setTitle(value as string);
        break;
      }

      case D3EAppTemplateCategory._APPS: {
        this.setApps((value as Array<any>).cast<D3EAppTemplate>().toList());
        break;
      }
    }
  }
}
